var map = {
	"./bay.svg": "e658",
	"./bbl.svg": "b10d",
	"./cimb.svg": "3d65",
	"./gsb.svg": "2fbf",
	"./kbank.svg": "710f",
	"./ktb.svg": "f552",
	"./scb.svg": "2ae5",
	"./tbank.svg": "9b14",
	"./tmb.svg": "c546",
	"./uob.svg": "543e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0520";